<div>
  <fz-copy-link
    [label]="shareLabel"
    [link]="profileLink"
    [linkMaxHeigh]="true"
    (oncopy)="onEvent('onCopyLinkShare')"
  ></fz-copy-link>
  <h3 class="share-label mat-body-large">Share through socials or email</h3>
  <div class="share-grid">
    @for (item of shareOptions; track $index) {
      <a class="share-grid-item" [ngClass]="{ hide: item.hideOnMobile }">
        <div
          class="share-grid-item-content share-option-item"
          [class.enabled]="item.enabled"
          (click)="onEvent(item.function)"
        >
          <img [src]="item.icon" aria-label="Icon" alt="Icon" />
          <div class="cap">
            <span class="mat-caption mat-label-small">{{ item.name }}</span>
          </div>
        </div>
      </a>
    }
  </div>
</div>
